import { GuideStep } from "views/components/Guide";

import {
  PropagateScene,
  ChooseLabelsScene,
  DragSeedScene,
  StartScene,
  MarkerScene,
} from "./art/SeedScenes";

export const LP_SEED_GUIDE_STEPS: GuideStep[] = [
  {
    title: "A few examples label the whole dataset",
    body: (
      <p>
        You seed each label with a few images. Visual Layer labels the rest and
        asks you only about the unsure ones.
      </p>
    ),
    tip: "Each image gets one propagated label. Imported AOI labels stay as a separate source and are never changed.",
    art: <PropagateScene />,
  },
  {
    title: "Choose your labels",
    body: (
      <p>
        Pick at least two labels. Include every label that can appear, since
        none can be added later.
      </p>
    ),
    tip: "The list comes from classes.json of your AOI folders. The class list is fixed when the dataset is created.",
    art: <ChooseLabelsScene />,
  },
  {
    title: "Add 5 seeds per label",
    body: (
      <p>
        Drag images or clusters onto a label card, or select images and use{" "}
        <strong>Assign Label</strong>.
      </p>
    ),
    tip: "More seeds now means fewer review rounds later.",
    art: <DragSeedScene />,
  },
  {
    title: "Judge by the pink box",
    body: (
      <p>
        The pink square on every image marks the area the AOI inspected. Use an
        image as a seed for a defect only when the defect is{" "}
        <strong>inside</strong> that box. A defect outside the box belongs to a
        different image, so do not label this one as that defect.
      </p>
    ),
    tip: "The same rule applies when you review batches later. Open the image to zoom in if the box is small.",
    art: <MarkerScene />,
  },
  {
    title: "Check, then start",
    body: (
      <p>
        Seeds lock once propagation starts. Click{" "}
        <strong>Start Label Propagation</strong> and wait for the first review
        batch.
      </p>
    ),
    tip: "Running Label Propagation again later replaces all previous propagated labels. To keep them, add those images as seeds first.",
    art: <StartScene />,
  },
];
